import { QuickNavContent } from './QuickNavContent'
import { useGetAppMenu } from '../../AppMenu/useGetAppMenu'
export function QuickNavComponent() {
  const { data } = useGetAppMenu()
  return <QuickNavContent items={data.items} />
}

export function QuickNavLoading() {
  return 'Loading...'
}
